<div class='wrapBtnBack'>
  <meSvg svgName='arrow_left&20' class='wrapBtnBack__svgLeft'></meSvg>
  <span *ngIf='text'>{{text}}</span>
</div>